import { NgModule } from '@angular/core';
import { CrmInjectionToken, CrmMultilocationInjectionToken } from './providers';
import { CRM_ACCESS_SERVICE_TOKEN, CrmCoreModule } from '@galaxy/crm/static';
import { CRM_ROUTES, CrmModule } from '@galaxy/crm/dynamic';
import { CRMAccessService } from './access.service';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild(CRM_ROUTES),
    CrmCoreModule.forRoot(CrmInjectionToken, CrmMultilocationInjectionToken),
    CrmModule,
  ],
  providers: [{ provide: CRM_ACCESS_SERVICE_TOKEN, useExisting: CRMAccessService }],
})
export class BusinessCrmModule {}
